<template lang="pug">
	.keywords-selection
		.header-data
			h2.content-block.header {{$tCaption('Keywords selection')}}
		.widgets-area.segment
			DxResponsiveBox(:screen-by-width="screen", single-column-screen="xs sm")
				DxRow(:ratio="1")
				DxCol(:ratio="1")
				DxItem()
					DxLocation(:row="0", :col="0")
					template(v-slot:default)
						.widgets
							.widget
								.data-vertical
									DxTagBox(
										:items="keywords",
										:accept-custom-value="true",
										:search-enabled="true",
										:value="data.keywords",
										:show-selection-controls="true",
										:openOnFieldClick="false",
										@value-changed="v => data.keywords = v.value")
										DxTagBoxButton(v-if="!data.keywords.length", name="help", :options="{text: $tCaption('I need help'), icon: 'help', stylingMode: 'text', onClick: () => popupVisible = true}")
										DxTagBoxButton(v-if="data.keywords.length", name="clearAll", :options="{text: '', icon: 'clear', type: 'default', onClick: () => data.keywords = []}")
		DxPopup(
			:visible.sync="popupVisible"
			:drag-enabled="false"
			:close-on-outside-click="true"
			:show-title="false"
			:width="960"
			:height="450"
			maxWidth="90%",
			maxHeight="90%"
		)
			.carto-map--popup-content
				DxScrollView(height="100%", showScrollbar="always")
					.content
						KeywordsSuggester(:data="data", @get-keywords="onGetKeywords")
</template>

<script>
	import axios from 'axios';
	import VueTypes from 'vue-types';
	import { DxTagBox, DxButton as DxTagBoxButton  } from 'devextreme-vue/tag-box';
	import DxButton from 'devextreme-vue/button';
	import { DxResponsiveBox, DxItem, DxLocation, DxCol, DxRow } from 'devextreme-vue/responsive-box';
	import api from '../carto/api.js';
	import { DxPopup } from 'devextreme-vue/popup';
	import DxScrollView from 'devextreme-vue/scroll-view';
	import KeywordsSuggester from './KeywordsSuggester.vue';

	export default {
		translationCategory: 'proposal.KeywordsSelection',
		name: 'keywords-selection',
		components: {
			DxButton,
			DxResponsiveBox,
			DxItem,
			DxLocation,
			DxCol,
			DxRow,
			DxTagBox,
			DxTagBoxButton,
			DxPopup,
			DxScrollView,
			KeywordsSuggester
		},
		props: {
			data: VueTypes.object.def({}),
			iabCategories: VueTypes.array.def([])
		},
		data() {
			return {
				screen(width) {
					return (width < 900) ? 'xs' : 'lg';
				},
				keywords: [],
				popupVisible: false
			};
		},
		mounted() {
			if (__DEBUG__)
				console.log('Keywords selection mounted', this);
		},
		methods: {
			onGetKeywords(v) {
				this.data.keywords = v;
				this.popupVisible = false;
			}
		}
	};
</script>
<style lang='scss'>
	.keywords-selection {
	}
</style>
